module.exports = __webpack_public_path__ + "static/screen4-a31388d53326a16e779c2abd9c751380.webp";